import { render } from "./TypeViewModal.vue?vue&type=template&id=284994c6"
import script from "./TypeViewModal.vue?vue&type=script&lang=js"
export * from "./TypeViewModal.vue?vue&type=script&lang=js"
script.render = render

export default script